export default {
  title: {
    'zh-cn': '全局管理',
    'zh-tw': '全局管理',
    'en': 'Global Management'
  },
  // 搜索表单
  deviceNumber: {
    'zh-cn': '设备编号',
    'zh-tw': '設備編號',
    'en': 'Device Number'
  },
  pleaseInputKeyword: {
    'zh-cn': '请输入关键字',
    'zh-tw': '請輸入關鍵字',
    'en': 'Please input keyword'
  },
  query: {
    'zh-cn': '查询',
    'zh-tw': '查詢',
    'en': 'Query'
  },
  // Tab标签
  enterpriseRelationship: {
    'zh-cn': '企业关系',
    'zh-tw': '企業關係',
    'en': 'Enterprise Relationship'
  },
  // 卡片标题
  deviceInfo: {
    'zh-cn': '设备信息',
    'zh-tw': '設備信息',
    'en': 'Device Information'
  },
  // 表格列
  deviceType: {
    'zh-cn': '设备类型',
    'zh-tw': '設備類型',
    'en': 'Device Type'
  },
  status: {
    'zh-cn': '状态',
    'zh-tw': '狀態',
    'en': 'Status'
  },
  // 消息提示
  noDevId: {
    'zh-cn': '无devId',
    'zh-tw': '無devId',
    'en': 'No devId'
  },
  // 编辑设备对话框
  editDevice: {
    'zh-cn': '修改设备',
    'zh-tw': '修改設備',
    'en': 'Edit Device'
  },
  deviceAccount: {
    'zh-cn': '设备账号',
    'zh-tw': '設備賬號',
    'en': 'Device Account'
  },
  devicePassword: {
    'zh-cn': '设备密码',
    'zh-tw': '設備密碼',
    'en': 'Device Password'
  },
  sipProtocol: {
    'zh-cn': 'SIP传输协议',
    'zh-tw': 'SIP傳輸協議',
    'en': 'SIP Transport Protocol'
  },
  sipProtocolTooltip: {
    'zh-cn': '国标视频SIP信令传输协议',
    'zh-tw': '國標視頻SIP信令傳輸協議',
    'en': 'National Standard Video SIP Signaling Transport Protocol'
  },
  pleaseSelectChannelType: {
    'zh-cn': '请选择通道类型',
    'zh-tw': '請選擇通道類型',
    'en': 'Please select channel type'
  },
  editSuccess: {
    'zh-cn': '修改成功',
    'zh-tw': '修改成功',
    'en': 'Edit successful'
  },
  // 验证消息
  deviceSNLengthLimit: {
    'zh-cn': '设备SN长度为32个字符以内',
    'zh-tw': '設備SN長度為32個字符以內',
    'en': 'Device SN length should be within 32 characters'
  },
  deviceAccountLengthLimit: {
    'zh-cn': '设备账号长度为16个字符以内',
    'zh-tw': '設備賬號長度為16個字符以內',
    'en': 'Device account length should be within 16 characters'
  },
  devicePasswordLengthLimit: {
    'zh-cn': '设备密码长度为16个字符以内',
    'zh-tw': '設備密碼長度為16個字符以內',
    'en': 'Device password length should be within 16 characters'
  },
  channelNumberLengthLimit: {
    'zh-cn': '通道号长度限制为20个字符以内',
    'zh-tw': '通道號長度限制為20個字符以內',
    'en': 'Channel number length should be within 20 characters'
  },
  pleaseSelectGroup: {
    'zh-cn': '请选择所属分组',
    'zh-tw': '請選擇所屬分組',
    'en': 'Please select group'
  }
}

